import axios from "axios";
import { api } from "./api.service";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { store } from "../redux/store";
import { authUser, setUserInfo } from "../store/userInfoSlice";
import { setAuth } from "./auth.service";
import { ROUTES } from "../router/constants";

async function handleSignin(
  email: string,  
  password: string
): Promise<any> {
  try {
    
    const {data: {access_token, user}} = await api.post(`/auth`,
      {
        email: email,  
        password: password,    
      }
    );

    if(access_token){
      localStorage.setItem('token', JSON.stringify(access_token))
      
      // Salvar dados do usuário na store
      store.dispatch(setUserInfo({
        id: user.id,
        name: user.name,
        email: user.email,
        role: user.role,
        profile: user.profile || null,
        // Quando role for DOCTOR, o backend envia o objeto doctor com doctorId e locals
        doctor: user.doctor || null,
      }));
      
      toast.success("Usuario Autenticado!")
      setAuth(access_token)
      
      // Controle de rota pós-login baseado na role
      const isUserRole = String(user.role || "").toLowerCase() === "user";

      if (isUserRole && !user.profile) {
        // Usuário do tipo "user" sem perfil completo vai direto para o perfil
        window.location.replace(ROUTES.USER_PROFILE);
      } else if (isUserRole) {
        // Usuário do tipo "user" com perfil completo vai para a home (Homepage)
        window.location.replace(ROUTES.HOME);
      } else {
        // Qualquer usuário que NÃO seja "user" vai para o Dashboard
        window.location.replace(ROUTES.DASHBOARD);
      }
    }
    console.log(user)
    return access_token
    
  } catch (error: any) {
    const erro = error.response
      ? `
      ${error?.response?.data?.message}  
      ${error?.response?.status}`
      : error.message;
    
    toast.error("ops, tivemos um problema para enviar as informações! tente novamente")
        
    console.log("Erro", erro);
    return;
  }
}

export { handleSignin };
